
import React, { useRef, useState } from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import Select,{
    GroupBase,
    MultiValue,
    SelectInstance,
    SingleValue,
} from 'react-select';
import { OptionProp } from '~/models/Comons';
import { fontWeightClass } from '~/assets/styles/classes/InputClasses';

interface SelectProps {
    label: string;
    id: string;
    isMulti?: boolean;
    value?: OptionProp | OptionProp[];
    fontWeight?: 'bold' | 'normal' | 'extrabold';
    onChange: (param: OptionProp | OptionProp[]) => void;
    options: OptionProp[];
    hideLabel?: boolean;
    errorLabel?: string;
    isDisabled?: boolean;
    hideErrorLabel?: boolean;
    menuPortal?: boolean;
    isRequired?: boolean;
    placeholder?:string
}

export const SIMPLSelectDropdown: React.FC<SelectProps> = ({
    id,
    isMulti = false,
    onChange,
    options,
    value,
    errorLabel = '',
    isDisabled = false,
    hideErrorLabel = false,
    label,
    hideLabel,
    menuPortal = false,
    placeholder,
    isRequired,
    fontWeight='bold'
    
}) => {
    const selectRef = useRef<SelectInstance<OptionProp, true, GroupBase<OptionProp>> | null>(null);
    const [focus, setFocus] = useState(false);

    const hasSingleValue =
    Array.isArray(value) && value.length > 0 && value[0]?.label !== '';
const hasMultipleValue = Array.isArray(value) && value.length > 1;
const singleObjectValue =
    !Array.isArray(value) && value !== null && value?.label !== '';

const handleSelectChange = (
    selectedOption: SingleValue<OptionProp> | MultiValue<OptionProp>
) => {
    if (Array.isArray(selectedOption)) {
        return onChange(selectedOption);
    } else if (selectedOption && 'value' in selectedOption) {
        onChange({ ...selectedOption });
    }

    selectRef?.current?.blur();
    setFocus(false);
};
const getBoxShadow = (focus:boolean, errorLabel:string) => {
    if (!focus) return 'none';
    return errorLabel ? '0 0 0 0px red' : '0 0 0 1px #9B0D78';
  };
  
    const hasValue = Array.isArray(value)
    ? value.length === 0
    : hasSingleValue || hasMultipleValue || singleObjectValue;
    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            width: 'auto',
            height: '44px',
            backgroundColor: '#F5F5F5',
            borderColor: errorLabel ? 'red' : '#B0B3BA',
            outline: 'none',
            '&:hover': {
                borderColor: 'none', 
            },
            boxShadow:getBoxShadow(focus,errorLabel) 
        }),
        option: (provided: any) => ({
            ...provided,
            color: '#6B6F7B',
            fontSize: '0.875rem',
            backgroundColor: '#F5F5F5',
          '&:hover': {
                backgroundColor: '#CFE0FC',
            },
        }),
        placeholder: (provided: any) => ({
            ...provided,
            color: errorLabel?'#CA3532':'#6B6F7B',
        }),
    };

    return (
      <div>
          {!hideLabel && (
                        <label
                            htmlFor={id}
                            className={`inline-block cursor-pointer text-sm ${fontWeightClass(fontWeight)} ${errorLabel ? 'text-error' : ''}`}
                        >
                            {isRequired && <span className="text-red-500">*</span>} {label}
                        </label>
                    )}
       <div className="w-full relative">
            <Select
                id={id}
                menuPlacement="auto"
                isDisabled={isDisabled}
                className={`select-container ${errorLabel ? 'placeholder:text-[#CA3532]' : ''}`}
                placeholder={placeholder}
                ref={selectRef}
                styles={customStyles}
                onChange={handleSelectChange}
                options={options}
                menuIsOpen={focus}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                components={{ IndicatorSeparator: () => null }}
                isMulti={isMulti}
                data-testid="select-input"
                value={hasValue || isMulti ? value : null}
                menuPortalTarget={menuPortal ? document.body : null}
            />
            {!hideErrorLabel && errorLabel && (
                <p className="pt-1 mb-4 text-error text-sm">{errorLabel}</p>
            )}

            <div className="text-sm">
                <label
                    htmlFor={id}
                    data-testid="select-label"
                    className={`text-sm tracking-wider font-bold ${errorLabel ? 'text-error' : ''}`}
                >
                    {errorLabel && 
                    <div className="flex items-center">
                      
                    <span className="flex items-center justify-center w-14px h-14px p-1 font-sans text-sm font-normal leading-[18px] text-left text-error">
                        <HighlightOffRoundedIcon 
                            id='icondrop'
                            fontSize='small' 
                        />
                    </span>
                    <span className="text-sm font-normal leading-[18px]">{errorLabel}</span>
                </div>
                }
                </label>
            </div>

        </div>
      </div>
       
    );
};